import {InstallerBridge} from '../installerBridge';

const installerWeb: InstallerBridge = {
    setFileOperationView: async (): Promise<void> => undefined,
    subscribe: async (): Promise<number> => -1,
    unsubscribe: async (): Promise<boolean> => false
};

export default installerWeb;
